// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041707/js/" + chunkId + "." + {"44":"6107d9c0","225":"106c4955","481":"28fff303","486":"758a6631","770":"b6cc2a0a"}[chunkId] + ".0.029910621142463123.chunk.js";
};